
































import Vue from "vue";
import Component from "vue-class-component";

@Component
export default class Timer extends Vue {
  // DATA
  timerId: any = null;
  secondsLeft = "0";
  minutesLeft = "0";
  timeLeft = 0;

  // METHODS
  startTimer() {
    this.timeLeft =
      60 * parseInt(this.minutesLeft) + parseInt(this.secondsLeft);
    this.timerId = setInterval(() => {
      if (this.timeLeft === 0) {
        alert("Time's up!");
        clearInterval(this.timerId);
        this.timerId = null;
      } else {
        this.timeLeft--;
      }
    }, 1000);
  }

  notate(seconds: number) {
    let hours = 0;
    let minutes = 0;

    while (seconds > 60) {
      seconds -= 60;
      minutes++;
    }

    while (minutes > 60) {
      minutes -= 60;
      hours++;
    }

    return `${minutes} minutes ${seconds} seconds`;
  }

  cancelTimer() {
    clearInterval(this.timerId);
    this.timerId = null;
    this.secondsLeft = "";
    this.minutesLeft = "";
    this.timeLeft = 0;
  }
}
